<mat-sidenav-container class="sidenav-container" >
  <mat-sidenav
    #drawer
    class="sidenav"
    fixedInViewport
    [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'"
    [opened]="(isHandset$ | async) === false"
    *ngIf="authService.visible"
   
  >
    <mat-toolbar *ngIf="authService.isLoggedIn == false">
      <img
        src="../../../assets/imgs/icon.svg"
        class="img-fluid logo-icon-resize"
      />
    </mat-toolbar>

    <mat-toolbar *ngIf="authService.isLoggedIn == true">
      <div class="pt-5" *ngIf="authService.userData as user">
        <img
          class="align-self-start mr-5 img-thumbnail rounded-circle profile-photo"
          src="{{ user.photoURL ? user.photoURL : '/assets/dummy-user.png' }}"
          alt="profile"
        />
      </div>
    </mat-toolbar>

    <div class="pb-3"></div>
    <mat-nav-list
      class="nav flex-column"
      *ngIf="authService.isLoggedIn == true"
    >
      <mat-list class="nav flex-column">
        <mat-list-item class="mat-item-list">
          <a mat-button class="" routerLinkActive="active" routerLink="/account">
            <mat-icon>account_box</mat-icon> Account
          </a>
        </mat-list-item>
        <mat-divider></mat-divider>

        <!--Entrep-Dashboard-->
        <div *ngIf="authService.isAdmin == false">
          <mat-list-item class="mat-item-list">
            <a mat-button class="" routerLinkActive="active" routerLink="/entrep-dash">
              <mat-icon>grid_view</mat-icon> Dashboard
            </a>
          </mat-list-item>
          <mat-divider></mat-divider>
        </div>

        <!--Super admin-Dashboard-->
        <div *ngIf="authService.isSuperAdmin">
          <mat-list-item class="mat-item-list">
            <a mat-button class="" routerLinkActive="active" routerLink="/super-admin/dashboard">
              <mat-icon>grid_view</mat-icon> Super Dashboard
            </a>
          </mat-list-item>
          <mat-divider></mat-divider>
        </div>

        <!-- admin-Dashboard-->
        <div *ngIf="authService?.isAdmin && !authService?.adminCode?.disabled">
          <mat-list-item class="mat-item-list">
            <a
              mat-button
            
              routerLinkActive="active"
              [routerLink]="[
                '/super-admin',
                'admin-details',
                authService?.adminCode?.value || authService?.adminCode,
                authService?.userData?.uid
              ]"
            >
              <mat-icon>grid_view</mat-icon> Admin Dashboard
            </a>
          </mat-list-item>
          <mat-divider></mat-divider>
        </div>

        <div *ngIf="!authService?.isAdmin">
          <mat-list-item class="mat-item-list">
            <a mat-button class="" routerLinkActive="active" routerLink="/action-plan">
              <mat-icon>storefront</mat-icon> Action Plan
            </a>
          </mat-list-item>
          <mat-divider></mat-divider>
        </div>

        <div *ngIf="!authService.isAdmin">
          <mat-list-item class="mat-item-list">
            <a mat-button class=""routerLinkActive="active" routerLink="/business-plan">
              <mat-icon>business_center</mat-icon> Business Plan
            </a>
          </mat-list-item>
          <mat-divider></mat-divider>
        </div>

       <!-- <div *ngIf="authService.isAdmin"> DISCONTINUED
          <mat-divider></mat-divider>
          <mat-list-item class="mat-item-list">
            <a
              mat-button
            
              routerLinkActive="active"
              routerLink="/model-assessments-lists"
            >
              <mat-icon>list</mat-icon> Model Lists
            </a>
          </mat-list-item>
          <mat-divider></mat-divider>
        </div>-->

      <!--  <div *ngIf="authService.isAdmin">DISCONTINUED
          <mat-divider></mat-divider>
          <mat-list-item class="mat-item-list">
            <a
              mat-button
            
              routerLinkActive="active"
              routerLink="/operating-assessments-lists"
            >
              <mat-icon>list</mat-icon> Operating List
            </a>
          </mat-list-item>
          <mat-divider></mat-divider>
        </div>-->
        <div *ngIf="authService.isAdmin">
          <mat-divider></mat-divider>
          <mat-list-item class="mat-item-list">
            <a
              mat-button
              routerLinkActive="active"
              routerLink="/business-assessments-lists"
            >
              <mat-icon>list</mat-icon> Business List
            </a>
          </mat-list-item>
          <mat-divider></mat-divider>
        </div>

        <mat-list-item class="mat-item-list">
          <a
            mat-button
          
            routerLinkActive="active"
            href="https://sustainible.io/resource-library/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <mat-icon>library_books</mat-icon> Resource Library
          </a>
        </mat-list-item>
        <mat-divider></mat-divider>

        <mat-list-item class="mat-item-list">
          <a mat-button class="" routerLinkActive="active" routerLink="/troubleshoot">
            <mat-icon>help</mat-icon> Help
          </a>
        </mat-list-item>
        <mat-divider></mat-divider>

        <mat-list-item class="mat-item-list">
          <a
            mat-button
          
            routerLinkActive="active"
            href="https://docs.google.com/forms/d/e/1FAIpQLSfJN-WKAh1VYvLt1SN05uDZqa_Ihm5N8dh3QRuBZjSB0C4rBw/viewform"
            target="_blank"
            rel="noopener noreferrer"
          >
            <mat-icon>feedback</mat-icon> Give Feedback
          </a>
        </mat-list-item>
      </mat-list>
    </mat-nav-list>
    <mat-nav-list
      class="nav flex-column"
      *ngIf="authService.isLoggedIn == false"
    >
      <mat-list class="nav flex-column">
        <mat-list-item class="mat-item-list">
          <a
            mat-button
           
            routerLinkActive="active"
            href="http://sustainible.io"
            target="_blank"
          >
            <mat-icon>home</mat-icon> Home
          </a>
        </mat-list-item>
        <mat-divider></mat-divider>

        <mat-list-item class="mat-item-list">
          <a
            mat-button
           
            routerLinkActive="active"
            href="http://sustainible.io/about-us"
            target="_blank"
          >
            <mat-icon>emoji_objects</mat-icon> About
          </a>
        </mat-list-item>
        <mat-divider></mat-divider>
      </mat-list>
    </mat-nav-list>
  </mat-sidenav>

  <mat-sidenav-content >
    <!--top menu-->
    <mat-toolbar color="primary">
      <!--Responsive Menu-->
      <button
        type="button"
        aria-label="Toggle sidenav"
        mat-icon-button
        (click)="drawer.toggle()"
        *ngIf="isHandset$ | async"
      >
        <mat-icon aria-label="Side nav toggle icon">menu_open</mat-icon>
      </button>

      <!--profile photo-->
      <div class="spacer"></div>

      <div *ngIf="authService.userData as user">
        <div class="test" *ngIf="authService.isLoggedIn == true">
          <span class="nav-txt">{{
            user.displayName ? user.displayName : "User | Entrepreneur"
          }}</span>
        </div>
      </div>
      <span class="nav-spacer"></span>

      <!--logout -->
      <button
        mat-button
        class="nav-txt"
        (click)="SignOut()"
        *ngIf="authService.isLoggedIn == true"
      >
        Logout
        <mat-icon>power_settings_new</mat-icon>
      </button>
      <button
        mat-button
        class="nav-txt"
        routerLink="/sign-in"
        *ngIf="authService.isLoggedIn == false"
      >
        Sign In
        <mat-icon>login</mat-icon>
      </button>
    </mat-toolbar>

    <!-- Add Content Here -->
    <div class="container-fluid">
      <router-outlet></router-outlet>
    </div>

    <!--<footer></footer>-->
  </mat-sidenav-content>
</mat-sidenav-container>
